import { createChatBotMessage } from 'react-chatbot-kit';

const config = {
  botName: 'TestBot',
  initialMessages: [
    createChatBotMessage(
      'Hi! Describe a JIRA feature and I’ll suggest matching tests.'
    ),
  ],
  customStyles: {
    botMessageBox: { backgroundColor: '#198754' },
    chatButton: { backgroundColor: '#198754' },
  },
  customComponents: {
    botAvatar: () => (
      <img
        src="/chat.png"
        alt="User"
        style={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          objectFit: 'cover',
        }}
      />
    ),
  },
};

export default config;
